<script>
	import { _, json } from 'svelte-i18n';
	import TopBar from './section/topBar.svelte';
	import Intro from './section/intro.svelte';
	import Description from './section/description.svelte';
	import Skills from './section/skills.svelte';
	import Experience from './section/experience.svelte';
	import Education from './section/education.svelte';
	import Footer from './section/footer.svelte';
	import ToggleGoUp from './ui/toggle/goUp.svelte';

	let scrollY;
</script>

<svelte:window bind:scrollY="{scrollY}"/>

<div>
	<TopBar isFixed=false logo={$_('logo')} menu={$json('menu')} languages={ $json('languages')}/>
	<Intro title={$_('info.personal.introduce')}/>
	<a id="about">
		<Description infoPersonal={$json('info.personal')}/>
	</a>
	<a id="skill">
		<Intro title={$_('titles.skill.title')} bg={$_('titles.skill.bg')}/>
		<div class="py-12">
			{#each $json('info.skill') as item, i}
				<Skills item={item}/>
			{/each}
		</div>
	</a>
	<a id="experience">
		<Intro title={$_('titles.experience.title')} bg={$_('titles.experience.bg')}/>
		<div class="py-12">
			{#each $json('info.work') as item, i}
				<Experience item={item}/>
			{/each}
		</div>
	</a>
	<a id="education">
		<Intro title={$_('titles.education.title')} bg={$_('titles.education.bg')}/>
		<div class="container mx-auto grid md:grid-cols-2 place-content-center py-12">
			{#each $json('info.education') as item, i}
				<Education item={item}/>
			{/each}
		</div>
	</a>
	<Footer infoPersonal={$json('info.personal')}/>
	<div class="hidden md:block">
		<TopBar isFixed=true logo='{$_('logo')}' menu={$json('menu')} languages={ $json('languages')}/>
	</div>
	{#if scrollY > 60}
		<ToggleGoUp/>
	{/if}
</div>


<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>